import { useQuery } from '@tanstack/react-query';
import { aggregateTokens, updateTokenPrices, priceToken, getLastKnownPrice, type TokenSummary } from '../tokens';
import type { Payout } from '../../types/payout';

// Seed avec le dernier prix connu (cache localStorage, voir priceCache.ts) pour afficher
// immédiatement des valeurs (même légèrement périmées) au lieu d'un écran de chargement plein
// écran tant que le queryFn n'a pas résolu le prix de chaque token.
const buildPlaceholderTokens = (payouts: Payout[] | undefined): TokenSummary[] | undefined => {
  if (!payouts || payouts.length === 0) return undefined;

  const aggregatedTokens = aggregateTokens(payouts, 0.34);
  return Array.from(aggregatedTokens.values()).map((token) => {
    const lastKnownPrice = getLastKnownPrice(token.crypto.id);
    return lastKnownPrice !== undefined ? priceToken(token, lastKnownPrice) : token;
  });
};

export function useTokenPrices(payouts: Payout[] | undefined) {
  return useQuery({
    queryKey: ['token-prices', payouts?.map(p => p.id) ?? []],
    queryFn: async () => {
      if (!payouts || payouts.length === 0) {
        return [];
      }

      const aggregatedTokens = aggregateTokens(payouts, 0.34);
      const tokenArray = Array.from(aggregatedTokens.values());
      const tokensWithPrices = await updateTokenPrices(tokenArray);
      return tokensWithPrices;
    },
    enabled: !!payouts && payouts.length > 0,
    placeholderData: () => buildPlaceholderTokens(payouts),
  });
}
